import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../constants/Endpoints/EndPoints";
import { FetchRequestHandler } from "../../utils/commonUtilities";


export const fetchPracticeLocationDetails = createAsyncThunk(
    "fetchPracticeLocationDetails",
    async (providerId) => {
        const result = await FetchRequestHandler(
          "get",
          `${baseUrl}api/providers/${providerId}/practices?status=ACTIVE`
        );
        return result;
      }   
)